import { useState } from "react";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const SupportLoginButton = ({ franchisee, to = "/billing/setup", compact = false }) => {
  const { startSupportLogin } = useAuth();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!window.confirm(`Log in as ${franchisee.full_name || franchisee.email}? You'll have full access to their portal for 2 hours, and the session is logged.`)) return;
    setBusy(true);
    try { await startSupportLogin(franchisee); window.location.assign(to); } catch (e) { toast.error(e.message); setBusy(false); }
  };
  return (
    <button onClick={go} disabled={busy} title="Log in as this franchisee" data-testid={`support-login-${franchisee.id}`}
      className={`flex items-center gap-1.5 rounded-lg border border-[var(--accent)] font-bold text-[var(--accent)] transition-colors hover:bg-[var(--accent)] hover:text-black disabled:opacity-50 ${compact ? "p-2" : "px-3 py-2 text-xs"}`}>
      <LogIn size={compact ? 16 : 14} />{!compact && "LOG IN AS FRANCHISEE"}
    </button>
  );
};
